<template>
  <v-snackbar
    :value="value"
    :timeout="timeout"
    :color="color"
    :top="top"
    :bottom="bottom"
    :left="left"
    :right="right"
    @input="updateValue"
  >
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="close">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "BaseSnackbar",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "success",
    },
    timeout: {
      type: Number,
      default: 3000,
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    },
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>
<style>
.v-snack__content{
    font-size: 1rem !important;
}
</style>